/*
Usage Notes:

The following web component can be dropped into any standard Shopify theme (i.e. non-headless), using Liquid to pass product data:

  {% assign skioSellingPlanGroups = product.selling_plan_groups | where: 'app_id', 'SKIO' %}
  {% if skioSellingPlanGroups.size > 0 %}
    <skio-plan-picker
      product='{{ product | json | escape }}'
      selectedVariant='{{ product.selected_or_first_available_variant | json | escape }}'
      formId='{{ product_form_id }}'
      currency='{{ cart.currency.iso_code }}'
      >
    </skio-plan-picker>
    <script src="{{ 'skio-plan-picker-component.js' | asset_url }}" type="module"></script>
    {% render 'skio-details' %}
  {% endif %}

  Note: formId not required if element is inside of a form already

  Example variantChanged event dispatch:
  document.dispatchEvent( new CustomEvent("variantChanged", { detail: { variantId: variant.id } }) );
*/

/* eslint-disable */
import { LitElement, html, css } from 'https://cdn.jsdelivr.net/gh/lit/dist@2/core/lit-core.min.js';

const skioStyles = css`
  .skio-plan-picker {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 0;
    border: 0;
    max-width: 415px;
    margin:0;

  }
  .skio-onetime-second {
    order: 2;
  }
  
  .skio-group-container {
    display: none;
  }
  .skio-group-container--available {
    display: block;
    position: relative;
    background-color: #fff;
    transition: background-color 0.2s ease;
    color: #2e3138;
    padding: 10px calc(var(--inputs-border-width) + 3rem) 10px 2rem;
  }
  .skio-group-container--available:first-child {
    border-top-right-radius: 12px;
    border-top-left-radius: 12px;
  }
  .skio-group-container--available:last-child {
    border-bottom-right-radius: 12px;
    border-bottom-left-radius: 12px;
  }

  .skio-group-container--selected {
    background-color: #ebedff;
  }
  .skio-group-container:hover {
    background-color: #ebedff;
  }
  .skio-group-input {
    position: absolute;
    width: 0px;
    height: 0px;
    opacity: 0;
  }
  .skio-group-input:focus-visible ~ .skio-group-label {
    outline: 2px #ccc solid;
    outline-offset: 4px;
    border-radius: 5px;
  }
  
  .skio-group-label {
    display: flex;
    flex-direction: column;
    cursor: pointer;
    overflow: hidden;
  }

  .skio-group-topline {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    font-size: 14px;
    line-height: 18px;
  }
  
  .skio-radio__container {
    display: flex;
    margin-right: 10px;
  }

  .skio-radio__container svg circle:first-child {
    stroke: #b0b7f1;
    stroke-width: 2px;
    transition: fill 0.2s ease;
  }

  .skio-group-container--selected .skio-radio__container svg circle:first-child {
    fill: #b0b7f1;
  }
  
  .skio-radio {
    transition: transform 0.25s cubic-bezier(0.4,0,0.2,1), opacity 0.25s cubic-bezier(0.4,0,0.2,1);
    transform-origin: center;
    transform: scale(0);
    opacity: 0;
  }
  .skio-group-label:hover .skio-radio {
    transform: scale(1);
    opacity: 0.75;
  }
  .skio-group-container--selected .skio-group-label .skio-radio {
    transform: scale(1);
    opacity: 1;
  }
  
  .skio-price {
    margin-left: auto;
  }
  
  .skio-group-content {
    width: auto;
    margin-left: 30px;
    transition: max-height 0.25s cubic-bezier(0.4,0,0.2,1),
                opacity 0.25s cubic-bezier(0.4,0,0.2,1);
    max-height: 38px;
    opacity: 1;
  }
  
  /* Hide frequency if not selected */
  .skio-group-container:not(.skio-group-container--selected) .skio-group-content {
    max-height: 0;
    opacity: 0;
    pointer-events: none;
  }
  
  .skio-group-title {
    min-width: max-content;
  }
  
  .skio-save {
    /* color: #0fa573;
    border: 1px #0fa573 solid; 
    padding: 0px 8px;
    border-radius: 20px; */
  }
  
  .skio-frequency {
    display: flex;
    align-items: center;
    gap: 5px;
    padding: 8px 30px 8px 10px;
    margin-top: 5px;
    border-radius: 5px;
    background-color: #f7f7f7;
    width: 100%;
    border: 0;
    font-size: 14px;
    white-space: nowrap;
    text-overflow: ellipsis;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
  }

  .skio-frequency.skio-frequency--one {
    background-image: none;
  }
  
  .skio-frequency span {
    text-transform: lowercase;
  }

  button.add-to-cart {
    justify-content: center;
    font-weight: 400;
    text-transform: capitalize;
    letter-spacing: 0;
    font-style: normal;
    font-size: 16px;
    text-decoration: none;
    box-shadow: 0 0 #0000004d inset;
    width: 100%;
    color: #fff;
    background-color: #5f3ebc;
    border-radius: 5px;
    transition-duration: .3s;
    padding: 10px 32px;
    text-transform: uppercase;
    cursor: pointer;
    font-family: 'FK Grotesk Neue Trial';
    transition: border-color 0.25s ease, background-color 0.25s ease, color 0.25s ease;

    border: solid 2px rgba(0,0,0,0);
  }
  button.add-to-cart:hover {
    background-color: rgba(0,0,0,0);
    color: #5f3ebc;
    border-color: #5f3ebc;
  }

  .skio-details {
    --text-color: #333;
    --text-color-secondary: #888; 
    
    user-select: none;
    -webkit-user-select: none;
    margin-bottom: 20px;
    margin-top: 10px;
  }

  .skio-details summary::-webkit-details-marker,
  .skio-details summary::marker {
    display: none;
    color: #fff !important;
  }

  .skio-details summary span {
    font-size: 0.9em;
    display: flex;
    padding: .5em 0;
    cursor: pointer;
    align-items: center;
    gap: 10px;
    text-decoration: underline;

    margin-top: -40px;
    color: #5f3ebc;
  }

  @keyframes fadeInDown {
    0% {
      opacity: 0;
      transform: translateY(-15px);
    }
    100% {
      opacity: 1;
      transform: translateY(0px);
    }
  }
  .skio-details[open] > .skio-details--content {
    animation-name: fadeInDown;
    animation-duration: 0.3s;
  }

  .skio-details--content {
    position: absolute;
    z-index: 1020;
    padding: 1em;
    width: fit-content;
    border-radius: 5px;
    background: white;
    box-shadow: 0 0 5px rgb(23 24 24 / 5%), 0 1px 2px rgb(0 0 0 / 7%);
  }

  .skio-details ul {
    margin: 0;
    padding: 0;
  }

  .skio-details ul li {
    display: flex;
    align-items: flex-start;
    gap: .75em;

    margin-bottom: 1em;
  }

  .skio-details .skio-content {
    display: flex;
    flex-direction: column;
  }

  .skio-details .skio-content p {
    font-size: 0.9em;

    margin-top: 0;
    margin-bottom: 0;

    letter-spacing: 0;
    line-height: 1.5;

    color: var(--text-color);
  }

  .skio-details ul li small {
    font-size: 0.7em;
    color: var(--text-color-secondary);
  }

  .skio-details .skio-icon {
    display: flex;

    width: 2.25em;
    height: 2.25em;

    color: var(--text-color);
    background: #f8f8f8;
    border-radius: 100%;

    flex-shrink: 0;
    align-items: center;
    justify-content: center;
  }

  .skio-details .skio-icon svg {
    width: 1.25em;
    height: 1.25em;

    color: inherit;
  }

  .skio-details--footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 0.9em;
  }

  .skio-details--footer a {
    color: var(--text-color);
  }

  .skio-manage-link {
    text-decoration: underline;
  }

  .powered-by-skio {
    font-size: 0.8em;

    display: flex;
    text-decoration: none;
    
    align-items: center;
    gap: 3px;
  }

  .skio-select__select{
    appearance: none;
    background-color: #FFF;
    font-family: var(--font-secondary);
    font-weight: 400;
    font-size: 16px;
    line-height: 26px;
    letter-spacing: .01em;
    color: #2e3138;
    min-width: 250px;
    width: 100%;
    box-sizing: border-box;
    transition: box-shadow var(--duration-short) ease;
    /*border-radius: 5px;
      border: 1px solid var(--neutral-20, #C4C9D6);
      padding: 0 calc(var(--inputs-border-width) + 3rem) 0 2rem; */
    padding: 0 0 0 2rem;
    border-radius: 12px;
    border: 1px solid #ACB6EF;
    background: url(/cdn/shop/files/Chevron_1.svg?v=1701199181) no-repeat right 16px center;
    margin: var(--inputs-border-width);
    min-height: calc(var(--inputs-border-width) * 2);
    height: 4.5rem;
  }

  .select.selectComponent{
    position: relative;
  }

  .select.selectComponent svg{
    transform: rotate(90deg);
    width: 18px;
    height: 11px!important;
    top: calc(50% - 0.4rem);
    pointer-events: none;
    position: absolute;
    right: calc(var(--inputs-border-width) + 1.5rem);
  }
  .skio-group-flex{
    display:flex;
    width: 100%;
    flex-direction:row;
    justify-content:space-between;
    align-items:center;
  }
  .group-titles{
    display:flex;
    flex-direction: column;
  }

  .custom-select {
    position: relative;
    display: inline-block;
  }

  .custom-select .select-selected {
    display: flex;
    align-items: center;
    height: 100%;
    font-family: Lato;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    cursor: pointer;
  }

  .custom-select .select-items {
    position: absolute;
    z-index: 1;
    left: 0;
    right: 0;
    border-top: none;
    border-radius: 0 0 4px 4px;
    max-height: 200px;
  }

  .custom-select .close {
    display: none !important;
  }

  .custom-select .skio-group-subtitle {
    color: #086399!important;
    font-size: 12px;
    line-height: 16px;
  }

  .skio-plan-picker label.form__label {
    margin-top: -8px!important;
  }

  .custom-select .custom--top {
    top: 100%;
  }
   
  .custom-select .custom--bottom  { 
    bottom: 100%!important;
    border-radius: 12px;
    border: 1px solid #ACB6EF;
  }
  .skio-frequency.arrow--top {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' class='h-6 w-6' fill='none' viewBox='0 0 24 24' stroke='currentColor' stroke-width='2'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M19 9l-7 7-7-7' /%3E%3C/svg%3E");
    background-position: right 10px top 50%;
    background-size: 18px;
    background-repeat: no-repeat;
  }
  /*
  .skio-frequency.arrow--bottom:before {
    content: "";
    position: absolute;
    width: 25px;
    height: 16px;
    top: 50%;
    right: calc(var(--inputs-border-width) + 0.5rem);
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' class='h-6 w-6' fill='none' viewBox='0 0 24 24' stroke='currentColor' stroke-width='2'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M19 9l-7 7-7-7' /%3E%3C/svg%3E");
    /*background-position: right 10px top 50%;*/
    background-size: contain;
    background-repeat: no-repeat;
    transform: rotate(180deg) translateY(50%);
  }
  */
  .skio-price>span{
    position: relative;
    margin-right: 20px;
    font-family: var(--font-primary);
    font-style: normal;
    font-weight: 700;
    line-height: 28px;
    letter-spacing: -.01em;
  }
  .decimals{
    position: absolute;
    font-size: 10px;
    top: -.8em;
    left: 100%;
  }

  @media screen and (min-width: 1200px) {
    .skio-select__select {
      width: 200px;
      min-width: 200px;
    }
    .custom-select .custom--bottom {
      top: 100% !important;
      bottom: unset !important;
    }
  }
`;

export class SkioPlanPickerComponent extends LitElement {
  static properties = {
    product: { type: Object },            //required
    productHandle: { type: String },      //optional (unless product isn't passed, then required)
    key: { type: String },                //optional, defaults to product.id; identifier for this instance of the Skio plan picker
    position: { type: String },
    formId: { type: String },             //optional; if passed, used to connect input fields to form
    needsFormId: { type: Boolean },       //optional, defaults to false; if true, element needs to be passed a formId, else it searches for a form

    subscriptionFirst: { type: Boolean }, //optional, defaults to false; if true, shows subscription option above onetime
    startSubscription: { type: Boolean }, //optional, defaults to false; if true, auto-selects subscription on page load
    discountFormat: { type: String },     //optional, defaults to percent; can also pass "fixed"
    
    currency: { type: String },           //optional, defaults to 'USD', but can pass any 3 char identifier
    language: { type: String },           //optional, defaults to 'en-US', but can pass any similarly formatted language identifier
    moneyFormatter: {},                   //placeholder for object

    externalPriceSelector: { type: String },      //optional, used to update the external price

    externalPriceSelectorWithCurrency: { type: String },      //optional, used to update the external price
  
    selectedVariant: { type: Object },    //placeholder for data
    skioSellingPlanGroups: {},            //placeholder for data
    availableSellingPlanGroups: {},       //placeholder for data
    selectedSellingPlanGroup: {},         //placeholder for data
    selectedSellingPlan: {},              //placeholder for data
    selectedSellingPlanId: {},            //placeholder for data


    defaultFrequency: {},                 //placeholder for data

    showAddToCartButton: { type: Boolean },

    meta: {},

    selectedOption: { type: Object },
    dropdownOpen: { type: Boolean },
  };

  static styles = skioStyles;

  constructor() {
    super();
    this.product = null;
    this.selectedVariant = null;

    this.productHandle = null;

    this.purchaseOption = 'onetime';
    this.position = '';

    this.key = null;
    this.formId = null;
    this.needsFormId = false;

    this.skioSellingPlanGroups = [];
    this.availableSellingPlanGroups = [];

    this.selectedSellingPlanGroup = null;
    this.selectedSellingPlan = null;
    

    this.startSubscription = false;
    this.subscriptionFirst = false;

    this.skioMainProduct = true;

    this.discountFormat = 'percent';

    this.externalPriceSelector = '[skio-external-price]';

    this.externalPriceSelectorWithCurrency = '[skio-external-price-with-currency]';

    this.currency = 'USD';
    this.language = 'en-US';
    this.selectedOption = {
        name: 'One-time Purchase',
        frequency: false,
        price: '',
        position: 'top',
    };

    this.moneyFormatter = new Intl.NumberFormat(this.language, {
      style: 'currency',
      currency: this.currency,
    });

    this.defaultFrequency = null;

    this.showAddToCartButton = false;

    this.meta = {};

  }

  // Helper method to get the current variant ID and update the component
  updateForCurrentVariant() {
    try {
      const variantIdInput = document.querySelector('[name="id"]');
      if (!variantIdInput) return;
      
      const currentVariantId = parseInt(variantIdInput.value);
      if (!currentVariantId || !this.product || !this.product.variants) return;
      
      const variant = this.product.variants.find(x => x.id == currentVariantId);
      if (!variant) return;
      
      if (!this.selectedVariant || this.selectedVariant.id !== variant.id) {
        this.selectedVariant = variant;
        
        // Update the component without dispatching additional events
        this.requestUpdate();
      }
    } catch (error) {
      this.log("Error in updateForCurrentVariant:", error);
    }
  }

  connectedCallback() {
    super.connectedCallback();

    if (this.startSubscription == true) {
      this.purchaseOption = 'subscription';
    }


    if(!this.product && this.productHandle) {
      this.fetchProduct(this.productHandle);
    }

    if (this.needsFormId && this.formId == null) {
      let forms = document.querySelectorAll('form[action="/cart/add"]');
      if (forms.length > 0) {
        let form;
        forms.forEach((el) => {
          if (el.hasAttribute('skio-key')) {
            if (el.getAttribute('skio-key') == this.key) form = el;
          }
        });
        if (!form) form = forms[0];
        this.formId = form.id;
        this.requestUpdate();
      }
    }
    let skio = this;
    this.selectedOption.position = skio.position

    // Listen for variantChanged event
    document.addEventListener("variantChanged", function(e) {
      //update variant id
      let variantId = e.detail.variantId;
      let variant = skio.product.variants.find(x => x.id == variantId);
      if (variant) skio.selectedVariant = variant;
      else skio.log("Unable to find variant with id: ", variantId);
      skio.requestUpdate();
    });

    // Add listener for variant select elements to update the component
    const variantSelects = document.querySelectorAll('variant-selects');
    variantSelects.forEach(variantSelect => {
      // Listen for native variant-selects change events
      variantSelect.addEventListener('change', function(e) {
        // Don't use stopPropagation here as it might interfere with Shopify's native handlers
        setTimeout(() => {
          skio.updateForCurrentVariant();
        }, 100); // Small delay to ensure the variant has been updated in the form
      });
      
      // Also listen for individual select changes within the variant-selects element
      const selectElements = variantSelect.querySelectorAll('select');
      selectElements.forEach(select => {
        select.addEventListener('change', function(e) {
          // We're listening for changes, but not stopping them from propagating
          setTimeout(() => {
            skio.updateForCurrentVariant();
          }, 100); // Small delay to ensure the variant has been updated in the form
        });
      });
    });

    // Update our component's variant value without interfering with Shopify's event handling
    try {
      if (typeof window.PUB_SUB_EVENTS !== 'undefined' && typeof window.subscribe === 'function') {
        window.subscribe(window.PUB_SUB_EVENTS.optionValueSelectionChange, (event) => {
          if (event && event.data) {
            // Just update our component without stopping Shopify's event propagation
            setTimeout(() => {
              skio.updateForCurrentVariant();
            }, 100);
          }
        });
      }
    } catch (error) {
      skio.log("Error subscribing to option change events:", error);
    }

    if (this.meta !== '') this.meta = JSON.parse(this.meta);

    console.log("SKIO META: ", this.meta);
    if (this.meta !== '') {
      //overwrite Add to cart button functionality
      let form = document.querySelector(`#${this.formId}`);
      console.log("SKIO META: overwrite add to cart button functionality, form: ", form);
      if (form) {
        let atc = form.querySelector(`button[name="add"][type="submit"]`);
        console.log("SKIO META: overwrite add to cart button functionality, atc: ", atc);
        if (atc) {
          atc.removeAttribute('type');
          atc.addEventListener('click', function(e){
            e.stopPropagation();
            e.stopImmediatePropagation();
            e.preventDefault();
            //add to cart with the metas

            skio.addToCartMeta();

          })
        }
      }
    }

    const skioPdp = document.querySelector('skio-plan-picker');
    if (skioPdp) {
      skioPdp.addEventListener('skio-pdp-select-selling-plan-group', function(e){
        if (e.detail.group == null) {
          skio.selectSellingPlanGroup(null, false);
        } else {
          skio.selectSellingPlanID(e.detail.selling_plan.id, e.detail.group, false);
        }
      })

      setTimeout(() => {
        skioPdp.addEventListener('skio-pdp-select-selling-plan-group', function(e){
          if (e.detail.group == null) {
            skio.selectSellingPlanGroup(null, false);
          } else {
            skio.selectSellingPlanID(e.detail.selling_plan.id, e.detail.group, false);
          }
        })
      }, 700);
     

      
    }

    // Add MutationObserver to watch for changes to the variant ID input
    const variantIdInput = document.querySelector('[name="id"]');
    if (variantIdInput) {
      const variantObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
            // Use a safe non-interfering update method
            setTimeout(() => {
              try {
                skio.updateForCurrentVariant();
              } catch (err) {
                // Silently handle errors to prevent crashes
              }
            }, 100);
          }
        });
      });
      
      variantObserver.observe(variantIdInput, { 
        attributes: true,
        attributeFilter: ['value']
      });
    }

  }

  render() {
    if(!this.product || !this.selectedVariant || !this.skioSellingPlanGroups || this.skioSellingPlanGroups.length == 0 || this.meta !== '') return;
    return html`
      <fieldset class="skio-plan-picker" skio-plan-picker="${ this.key }">
        <input ${ this.formId !== null ? html`form="${ this.formId }"` : '' } name="selling_plan" type="hidden" value="${ this.selectedSellingPlan !== null ? this.selectedSellingPlan?.id : ''}" />
        <input ${ this.formId !== null ? html`form="${ this.formId }"` : '' } name="properties[Discount]" type="hidden" value="${ this.selectedSellingPlan !== null ? this.discount(this.selectedSellingPlan).percent : '' }" 
          ?disabled="${ this.selectedSellingPlan == null ? true : false }" />
        <div class="select selectComponent">


        <div  class="custom-select skio-select__select select__select skio-frequency arrow--${this.selectedOption.position}" @change=${(e)=> selectChanged(e.target)}>
        <div class="select-selected" @click="${this.toggleDropdown}">
        <div class="skio-group-topline">
        <div>
        <div class="skio-group-title">
          ${ this.selectedOption.name}
        </div>
        ${ this.selectedOption.frequency ? html`
        <div class="skio-group-subtitle">
          ${ this.selectedOption.frequency }
        </div>
        ` : html`` }
        </div>
        <div class="skio-price" part="skio-price">
          <span skio-onetime-price>
            ${ this.selectedSellingPlan? this.price(this.selectedSellingPlan).toString().split('.')[0] : this.moneyFormatter.format(this.selectedVariant.price / 100).toString().split('.')[0] }
            <span class="decimals">
            ${ this.selectedSellingPlan? this.price(this.selectedSellingPlan).toString().split('.')[1] : this.moneyFormatter.format(this.selectedVariant.price / 100).toString().split('.')[1] }
            </span>
          </span>
        </div>
    </div>
        </div>
        <div class="custom--${this.selectedOption.position} select-items ${this.dropdownOpen ? 'open' : 'close'}">
        
            <div  class="select-item skio-group-container ${ this.product.requires_selling_plan == false ? 'skio-group-container--available' : '' } ${ this.selectedSellingPlanGroup == null ? 'skio-group-container--selected' : '' } ${ this.subscriptionFirst ? 'skio-onetime-second' : ''}" skio-group-container 
            @click=${() => {this.selectSellingPlanGroup(null); this.selectSellingPlanPDP(null, null) } } 
            id="skio-one-time-${ this.key }" class="skio-group-input" name="skio-group-${ this.key }"  value="" 
        skio-one-time ?checked=${ this.startSubscription == false && this.product.requires_selling_plan == false ? true : false }
            >
        <div class="skio-group-topline">
            One-time Purchase
            <div class="skio-price" part="skio-price">
              <span skio-onetime-price>${ this.moneyFormatter.format(this.selectedVariant.price / 100).toString().split('.')[0]}
                <span class="decimals">${ this.moneyFormatter.format(this.selectedVariant.price / 100).toString().split('.')[1]}</span>
              </span>
            </div>
        </div>
        </div>

        ${ this.availableSellingPlanGroups && this.availableSellingPlanGroups.length > 0 ? this.availableSellingPlanGroups.map((group, index) => 
            html`
            <template>
              ${ group && group.selling_plans && group.selling_plans.length > 0 ? group.selling_plans.map((selling_plan) => 
                      html`
              <div class="select-item skio-group-container skio-group-container--available ${ this.selectedSellingPlanGroup == group ? 'skio-group-container--selected' : '' }" 
                @click=${() => { this.selectSellingPlanID(selling_plan.id, group); this.selectSellingPlanPDP(selling_plan, group) } }
                id="skio-selling-plan-group-${ index }-${ this.key }" class="skio-group-input" name="skio-group-${ this.key }"
                value="${ selling_plan.id }" skio-selling-plans="${ group.id }" skio-selling-plan-group="${ group.id }" ?checked=${ this.selectedSellingPlanGroup == group ? true : false }
                >
                <div class="skio-group-label" for="skio-selling-plan-group-${ index }-${ this.key }">
                  <div class="skio-group-topline">
                    <div class="skio-group-flex">
                      <div class="group-titles">
                        <div class="skio-group-title">
                          ${ group.name == 'Subscription' ? 'Subscribe' : group.name }
                          ${ group.selected_selling_plan && this.discount(group.selected_selling_plan).percent !== '0%' ? html`
                            <span class="skio-save">& Save <span skio-discount>${ this.discountFormat == 'percent' ? this.discount(group.selected_selling_plan).percent : this.discount(group.selected_selling_plan).amount }</span></span>
                          ` : html`` }
                        </div>
                        <div class="skio-group-subtitle" value="${ selling_plan.id }" ?selected=${group.selected_selling_plan == selling_plan }>
                          ${ group.name == 'Subscription' ? `Delivery ${ selling_plan.name.toLowerCase() }` : `${ selling_plan.name }` }
                        </div>
                      </div>
                      <div class="skio-price" part="skio-price">
                        <span skio-subscription-price>
                          ${group.selected_selling_plan ? this.price(group.selected_selling_plan).toString().split('.')[0] : ''}
                          <span class="decimals">${group.selected_selling_plan ? this.price(group.selected_selling_plan).toString().split('.')[1] : ''}</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              `
              ): ''}
              </template>
        </div>
      </div>


            <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-caret" width="11" height="18" viewBox="0 0 11 18" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M0.252601 0.335647C0.619519 -0.0771359 1.25159 -0.114317 1.66437 0.252601L10.6644 8.2526C10.8779 8.44237 11 8.71437 11 9.00001C11 9.28565 10.8779 9.55765 10.6644 9.74742L1.66437 17.7474C1.25159 18.1143 0.619519 18.0772 0.252601 17.6644C-0.114317 17.2516 -0.0771359 16.6195 0.335647 16.2526L8.49481 9.00001L0.335647 1.74742C-0.0771359 1.3805 -0.114317 0.74843 0.252601 0.335647Z" fill="#2E3138"></path>
            </svg>
            </div>
            ${ this.showAddToCartButton ? html`
              <button @click=${() => this.addToCart() } class="add-to-cart">Add to Cart</button>
            ` : html``}

          `
        ): ''}
      </fieldset>`
  }

  updated = (changed) => {
    if(changed.has('product') && this.product) {
      //update key
      this.key = this.key ? this.key : this.product.id;

      //update skioSellingPlanGroups
      this.skioSellingPlanGroups = this.product.selling_plan_groups.filter(
        selling_plan_group => selling_plan_group.app_id === 'SKIO'
      ) || [];

      this.skioSellingPlanGroups.forEach((group) => {
        if (group && group.selling_plans) {
          group.selling_plans.sort(function(a,b){
            if (parseInt(a.name.replace(/\D/g, "")) < parseInt(b.name.replace(/\D/g, ""))) return -1;
            if (parseInt(a.name.replace(/\D/g, "")) > parseInt(b.name.replace(/\D/g, ""))) return 1;
            if (parseInt(a.name.replace(/\D/g, "")) == parseInt(b.name.replace(/\D/g, ""))) return 0;
          });
        }
      });

    }

    if(changed.has('selectedVariant') && this.selectedVariant) {
      // Filter available groups and plans first
      const skioSellingPlanGroups = JSON.parse(JSON.stringify(this.skioSellingPlanGroups || []));
      this.availableSellingPlanGroups = skioSellingPlanGroups.filter(selling_plan_group =>
        selling_plan_group && selling_plan_group.selling_plans && 
        selling_plan_group.selling_plans.some(selling_plan =>
          this.selectedVariant.selling_plan_allocations && 
          this.selectedVariant.selling_plan_allocations.some(
            selling_plan_allocation => selling_plan_allocation.selling_plan_id === selling_plan?.id
          )
        )
      );

      this.availableSellingPlanGroups.forEach((group) => {
        if (group && group.selling_plans && this.selectedVariant.selling_plan_allocations) {
          group.selling_plans = group.selling_plans.filter(x => 
            x && this.selectedVariant.selling_plan_allocations.find(y => y.selling_plan_id === x.id)
          );
          // Set a default selected_selling_plan for the group if plans exist
          if (group.selling_plans.length > 0) {
             if (this.defaultFrequency) {
              let defaultPlan = group.selling_plans.find(x => x && x.name.toLowerCase().includes(this.defaultFrequency.toLowerCase()));
              group.selected_selling_plan = defaultPlan || group.selling_plans[0];
            } else {
              group.selected_selling_plan = group.selling_plans[0];
            }
          } else {
            group.selected_selling_plan = null; // No plans available for this group with this variant
          }
        }
      });
      
      // Now, determine the actual selected plan based on purchaseOption and availability
      let finalGroup = null;
      let finalPlan = null;
      
      // Check if subscription is intended and available for the new variant
      const canSubscribe = this.availableSellingPlanGroups.some(g => g && g.selling_plans && g.selling_plans.length > 0);
      
      if ((this.purchaseOption === 'subscription' || this.product.requires_selling_plan) && canSubscribe) {
         // Prefer the first available group and its default plan
         finalGroup = this.availableSellingPlanGroups.find(g => g && g.selling_plans && g.selling_plans.length > 0);
         if (finalGroup) {
           finalPlan = finalGroup.selected_selling_plan;
         }
      }
      
      // Set the final state
      this.selectedSellingPlanGroup = finalGroup;
      this.selectedSellingPlan = finalPlan;
      this.purchaseOption = finalPlan ? 'subscription' : 'onetime'; // Update purchaseOption based on result

      // Update selectedOption for the display
      if (finalPlan && finalGroup) {
        const group = finalGroup;
        const selling_plan = finalPlan;
        this.selectedOption.name = (group.name == 'Subscription') ? 'Subscribe' : group.name;
        let discountCalc = (this.discount(selling_plan)?.percent !== '0%') ? ' & save ' : '';
        const discountValue = this.discount(selling_plan);
        if (discountValue) {
          discountCalc += (this.discountFormat == 'percent') ? discountValue.percent : this.money(discountValue.amount);
        }
        this.selectedOption.name += discountCalc;
        this.selectedOption.frequency = (group.name == 'Subscription') ? `Delivery ${ selling_plan.name?.toLowerCase() }` : `${ selling_plan.name }`;
      } else {
        // Default to one-time display
        this.selectedOption.name = 'One-time Purchase';
        this.selectedOption.frequency = false;
      }

      //update the form that was passed, if any
      this.updateForm();
      // Force a re-render after state changes
      this.requestUpdate(); 
    }

    if(changed.has('selectedSellingPlan')) {
      //update price of price elements if applicable
      document.querySelectorAll(`[skio-price][skio-key="${ this.key }"]`).forEach((el) => {
        if(this.price(this.selectedSellingPlan)){
          var priceValue = this.price(this.selectedSellingPlan);
          var priceValuefloat = parseFloat(priceValue).toFixed(2);
          priceValuefloat = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(priceValuefloat);
          el.innerHTML = `${priceValuefloat.split('.')[0]}<span class="decimals">${priceValuefloat.split('.')[1]}</span>`;
        }
      });

      //update display of external content elements
      document.querySelectorAll(`[skio-onetime-content][skio-key="${ this.key }"]`).forEach((el) => {
        this.selectedSellingPlan !== null ? el.style.display = "none" : el.style.removeProperty('display');
      });

      document.querySelectorAll(`[skio-subscription-content][skio-key="${ this.key }"]`).forEach((el) => {
        this.selectedSellingPlan == null ? el.style.display = "none" : el.style.removeProperty('display');
      });

      //dispatch CustomEvent to tell that this specific plan picker was updated, and pass the selectedSellingPlan
      const event = new CustomEvent(`skio::update-selling-plan`, {
        bubbles: true, 
        composed: true, 
        detail: {
          sellingPlan: this.selectedSellingPlan,
          key: this.key
        }
      });

      this.dispatchEvent(event);

      //update the form that was passed, if any
      this.updateForm();
      this.updateExternalPrice();

    }

    if(changed.has('formId')) {
      //update the form that was passed, if any
      this.updateForm();
    }

  }

  log = (...args) => {
    args.unshift('%c[skio]', 'color: #8770f2;');
    console.log.apply(console, args);
  }

  error = (...args) =>  {
    args.unshift('%c [skio]', 'color: #ff0000');
    console.error.apply(console, args);
  }

  getMetadata(field) {
    let meta = this.meta;
    if (Object.keys(meta).length > 0) {
      let fieldData = meta[field];
      if (fieldData) return fieldData;
      else return '';
    }
    return '';
  }

  updateExternalPrice() {
    document.querySelectorAll(this.externalPriceSelector).forEach((el) => {
      let priceValue, priceValuefloat;

      if (this.selectedSellingPlan) {
        priceValue = this.price(this.selectedSellingPlan);
        priceValuefloat = parseFloat(priceValue).toFixed(2);
        if (! isNaN(priceValuefloat.split('.')[0])) {
          priceValuefloat = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(priceValuefloat);
          el.innerHTML = `${priceValuefloat.split('.')[0]}<span class="decimals">${priceValuefloat.split('.')[1]}</span>`;  
        }
      } else {
        priceValue = this.money( this.selectedVariant.price);
        priceValuefloat = parseFloat(priceValue).toFixed(2);
        if (! isNaN(priceValuefloat.split('.')[0])) {
          priceValuefloat = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(priceValuefloat);
          el.innerHTML = `${priceValuefloat.split('.')[0]}<span class="decimals">${priceValuefloat.split('.')[1]}</span>`;  
        }
      }
    })
    document.querySelectorAll(this.externalPriceSelectorWithCurrency).forEach((el) => {
      this.selectedSellingPlan ? el.innerHTML = this.price(this.selectedSellingPlan) + ' ' + this.currency : el.innerHTML = this.money( this.selectedVariant.price) + ' ' + this.currency;
    })
  }
  
  // Update selected selling plan; called on change of skio-frequency select element
  selectSellingPlanID(selling_plan_id, group) {
    this.dropdownOpen = false;
    let selling_plan = group?.selling_plans?.find(x => x.id == selling_plan_id);
    
    if (selling_plan && group) {
      this.purchaseOption = 'subscription'; // Explicitly set intent
      this.selectedSellingPlanGroup = group;
      this.selectedSellingPlan = selling_plan;
      group.selected_selling_plan = selling_plan; // Update the group's selected plan

      // Update the visual display (selectedOption)
      this.selectedOption.name = (group.name == 'Subscription') ? 'Subscribe' : group.name;
      let discountCalc = (this.discount(selling_plan)?.percent !== '0%') ? ' & save ' : '';
      const discountValue = this.discount(selling_plan);
      if (discountValue) {
        discountCalc += (this.discountFormat == 'percent') ? discountValue.percent : this.money(discountValue.amount);
      }
      this.selectedOption.name += discountCalc;
      this.selectedOption.frequency = (group.name == 'Subscription') ? `Delivery ${ selling_plan.name?.toLowerCase() }` : `${ selling_plan.name }`;

      this.updateForm();
      this.updateExternalPrice();
      this.requestUpdate(); // Ensure LitElement re-renders
    } else {
      this.log("Error: couldn't find selling plan with id " + selling_plan_id + " for variant " + this.selectedVariant?.id + " from product " + this.product?.id + " : " + this.product?.handle);
      this.selectSellingPlanGroup(null); // Fallback to one-time
    }
  }

  // Update selected selling plan group; called on click of skio-group-container element
  selectSellingPlanGroup(group) {
    this.dropdownOpen = false;
    
    if (group) {
      // User selected a subscription group
      this.purchaseOption = 'subscription'; // Explicitly set intent
      this.selectedSellingPlanGroup = group;
      this.selectedSellingPlan = group.selected_selling_plan; // Use the group's default/selected plan

      if (this.selectedSellingPlan) {
        // Update the visual display (selectedOption)
        const selling_plan = this.selectedSellingPlan;
        this.selectedOption.name = (group.name == 'Subscription') ? 'Subscribe' : group.name;
        let discountCalc = (this.discount(selling_plan)?.percent !== '0%') ? ' & save ' : '';
        const discountValue = this.discount(selling_plan);
        if (discountValue) {
          discountCalc += (this.discountFormat == 'percent') ? discountValue.percent : this.money(discountValue.amount);
        }
        this.selectedOption.name += discountCalc;
        this.selectedOption.frequency = (group.name == 'Subscription') ? `Delivery ${ selling_plan.name?.toLowerCase() }` : `${ selling_plan.name }`;
      } else {
         // Group selected, but it might not have a valid plan after filtering for the *current* variant
         // Fallback to one-time visually, but keep intent as subscription if possible
         this.purchaseOption = 'onetime'; // Revert intent if no plan is actually available
         this.selectedSellingPlanGroup = null;
         this.selectedSellingPlan = null;
         this.selectedOption.name = 'One-time Purchase';
         this.selectedOption.frequency = false;
      }
    } else {
      // User selected the one-time purchase option
      this.purchaseOption = 'onetime'; // Explicitly set intent
      this.selectedSellingPlanGroup = null;
      this.selectedSellingPlan = null;
      this.selectedOption.name = 'One-time Purchase';
      this.selectedOption.frequency = false;
    }

    //update the form that was passed, if any
    this.updateForm();

    const skioPriceUpdate = new CustomEvent('skio-price-update', {
      detail: { group: this.selectedSellingPlanGroup, selling_plan: this.selectedSellingPlan },
      bubbles: true,  
      composed: true, 
    });
    this.dispatchEvent(skioPriceUpdate);
    this.requestUpdate(); // Ensure LitElement re-renders
  }

  selectChanged(target) {
  }

  selectSellingPlanPDP(selling_plan, group) {
    const eventSelectSellingPlanGroup = new CustomEvent('skio-sticky-select-selling-plan-group', {
      detail: { group: group, selling_plan: selling_plan },
      bubbles: true,  
      composed: true, 
    });

 

    this.dispatchEvent(eventSelectSellingPlanGroup);

    // let selectSkio = document.querySelector('.skio-group-content select.skio-frequency'); 
   
  }

  // Formats integer value into money value
  money(price) {
    return this.moneyFormatter.format(price / 100.0)
  }

  // Calculates discount based on selling_plan.price_adjustments, returns { percent, amount } of selling plan discount
  discount(selling_plan) {
    if (!selling_plan || !selling_plan.price_adjustments || !selling_plan.price_adjustments.length) {
      return { percent: '0%', amount: 0 };
    }

    if (selling_plan.name && selling_plan.name.includes('prepaid')) {
      if (!selling_plan.options || !selling_plan.options.length) {
        return { percent: '0%', amount: 0 };
      }

      let option = selling_plan.options[0]['value'];
      var numberPattern = /\d+/g;
      let matches = option.match(numberPattern);
      
      if (!matches || !matches.length) {
        return { percent: '0%', amount: 0 };
      }
      
      let result = parseInt(matches.join(''));

      const price_adjustment = selling_plan.price_adjustments[0];
      const discount = { percent: '0%', amount: 0 };
      const price = this.selectedVariant ? this.selectedVariant.price * result : 0;
      
      if (!price_adjustment || !price) {
        return discount;
      }
      
      switch (price_adjustment.value_type) {
        case 'percentage':
          discount.percent = `${price_adjustment.value}%`;
          discount.amount = Math.round(
            (price * price_adjustment.value) / 100.0
          );
          break;
        case 'fixed_amount':
          discount.percent = `${Math.round(
            ((price_adjustment.value * 1.0) / price) * 100.0
          )}%`;
          discount.amount = price - price_adjustment.value;
          break;
        case 'price':
          discount.percent = `${Math.round(
            (((price - price_adjustment.value) * 1.0) /
              price) *
              100.0
          )}%`;
          discount.amount = price - price_adjustment.value;
          break;
      }
      
      return discount;
    } else {
      const price_adjustment = selling_plan.price_adjustments[0];
      const discount = { percent: '0%', amount: 0 };
      const price = this.selectedVariant ? this.selectedVariant.price : 0;
      
      if (!price_adjustment || !price) {
        return discount;
      }
      
      switch (price_adjustment.value_type) {
        case 'percentage':
          discount.percent = `${price_adjustment.value}%`;
          discount.amount = Math.round(
            (price * price_adjustment.value) / 100.0
          );
          break;
        case 'fixed_amount':
          discount.percent = `${Math.round(
            ((price_adjustment.value * 1.0) / price) * 100.0
          )}%`;
          discount.amount = price_adjustment.value;
          break;
        case 'price':
          discount.percent = `${Math.round(
            (((price - price_adjustment.value) * 1.0) /
              price) *
              100.0
          )}%`;
          discount.amount = price - price_adjustment.value;
          break;
      }
      
      return discount;
    }
  }

  // Calculates the variant's price for the given selling plan, returns a formatted money value (if desired)
  price(selling_plan, formatted = true) {
    if (!selling_plan || !this.selectedVariant) {
      return formatted ? this.money(0) : 0;
    }

    if (selling_plan.name && selling_plan.name.includes('prepaid')) {
      if (!selling_plan.options || !selling_plan.options.length) {
        return formatted ? this.money(this.selectedVariant.price / 100) : this.selectedVariant.price / 100;
      }

      let option = selling_plan.options[0]['value'];
      var numberPattern = /\d+/g;
      let matches = option.match(numberPattern);
      
      if (!matches || !matches.length) {
        return formatted ? this.money(this.selectedVariant.price / 100) : this.selectedVariant.price / 100;
      }
      
      let result = parseInt(matches.join(''));

      return formatted
        ? this.money((this.selectedVariant.price * result) - this.discount(selling_plan).amount)
        : (this.selectedVariant.price * result) - this.discount(selling_plan).amount;
    } else {
      return formatted
        ? this.money(this.selectedVariant.price - this.discount(selling_plan).amount)
        : this.selectedVariant.price - this.discount(selling_plan).amount;
    }
  }

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
    
    // If opening the dropdown, ensure we have the latest available selling plans
    if (this.dropdownOpen) {
      this.updateForCurrentVariant();
    }
  }

  selectOption(option) {
    this.selectedOption = option;
    this.options = this.options.map((o) => ({ ...o, selected: o.value === option.value }));
    this.dropdownOpen = false;
  }

  // If a formId was passed, appends the necessary <input> elements to the form
  updateForm() {
    if (this.formId) {
      let form = document.querySelector(`#${this.formId}`);

      if (form) {
        let selling_plan_input = form.querySelector('[name="selling_plan"]');
        if (selling_plan_input) {
          selling_plan_input.value = this.selectedSellingPlan?.id !== undefined ? this.selectedSellingPlan?.id : null;
          selling_plan_input.disabled = this.selectedSellingPlan?.id !== undefined ? false : true;
        } else {
          selling_plan_input = document.createElement('input');
          selling_plan_input.type = "hidden";
          selling_plan_input.name = "selling_plan";
          selling_plan_input.value = this.selectedSellingPlan?.id !== undefined ? this.selectedSellingPlan?.id : null;
          selling_plan_input.disabled = this.selectedSellingPlan?.id !== undefined ? false : true;
          form.append(selling_plan_input);
        }

        let discount_input = form.querySelector('[name="properties[Discount]"]');
        if (discount_input) {
          discount_input.value = this.selectedSellingPlan?.id !== undefined ? this.discount(this.selectedSellingPlan).percent : null;
          discount_input.disabled = this.selectedSellingPlan?.id !== undefined ? false : true;
        } else {
          discount_input = document.createElement('input');
          discount_input.type = "hidden";
          discount_input.name = "properties[Discount]";
          discount_input.value = this.selectedSellingPlan?.id !== undefined ? this.discount(this.selectedSellingPlan).percent : null;
          discount_input.disabled = this.selectedSellingPlan?.id !== undefined ? false : true;
          form.append(discount_input);
        }

      } else {
        console.log(`Skio error: form ID is ${ this.formId }, but no form with that ID was found.`);
      }
    }
  }

  // Optional functions keep if necessary 

  /**
   *   
   * 
   */
  
  // Runs a fetch request to add the selectedVariant to the cart with the passed quantity and selectedSellingPlan
  addToCart(quantity = 1) {
    const items = [
      {
        id: this.selectedVariant.id,
        quantity: quantity,
        ...(this.selectedSellingPlan && { selling_plan: this.selectedSellingPlan?.id })
      }
    ];

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items })
    })
    .then((response) => response.json())
    .then((response) => {
      this.log("SKIO added item to cart: ", response);
      //dispatch CustomEvent to tell document that an item was added to cart
      const event = new CustomEvent(`skio::added-to-cart`, {
        bubbles: true, 
        composed: true, 
        detail: {
          response,
          key: this.key
        }
      });

      this.dispatchEvent(event);
    })
    .catch((error) => {
      this.error(`SKIO ${ this.key } error adding item to cart: `, error);
    });
  } 

  addToCartMeta() {

    let items = [];

    let quantityEl = document.querySelector(`input[name="quantity"][form="${ this.formId }"]`);
    let quantity = 1;
    if (quantityEl) {
      quantity = quantityEl.value;
    }

    let variants = this.meta['variants'];
    let variantMeta = variants.find(x => x['variantId'] == this.selectedVariant.id);

    let code = variantMeta['discount'];
    let meta = variantMeta['addToCart'];
    meta.forEach((item) => {
      let i = {
        id: item['variantId'],
        quantity: parseInt(item['quantity']) * quantity
      }
      if (item['selling_plan'] !== 'null' && item['selling_plan'] !== null) {
        i['selling_plan'] = parseInt(item['selling_plan']);
      }
      items.push(i);
    })

    let cart = document.querySelector('cart-drawer');
    let sections;
    let sections_url;
    if (cart) {
      sections = cart.getSectionsToRender().map((section) => section.id);
      sections_url = window.location.pathname;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ 
        items,
        ...(sections && { sections: sections }),
        ...(sections_url && { sections_url: sections_url })
      })
    })
    .then((response) => response.json())
    .then((response) => {
      this.log("SKIO META added item to cart: ", response);
      //dispatch CustomEvent to tell document that an item was added to cart
      const event = new CustomEvent(`skio::added-to-cart`, {
        bubbles: true, 
        composed: true, 
        detail: {
          response,
          key: this.key
        }
      });

      this.dispatchEvent(event);

      console.log("SKIO CART TEST: " , cart);

      if (cart) {
        cart.renderContents(response);
        cart.classList.toggle('is-empty');
        cart.classList.toggle('active');
      }

      console.log("discount code: ", code);
      if (code) {
        window.location.href = '/checkout?discount=' + code; 
      } else {
        window.location.href = '/checkout'; 
      }
      
    })
    .catch((error) => {
      this.error(`SKIO META ${ this.key } error adding item to cart: `, error);
    });
  }

  fetchProduct = (handle) => {
    return fetch(`/products/${ handle }.js`)
    .then((response) => response.json())
    .then((product) => {
      this.product = product;
      this.selectedVariant = product.variants[0];
      console.log(this.selectedVariant);
      this.selectedOption.price = this.selectedVariant.price;
      return product;
    });
  }
}

customElements.define('skio-plan-picker-add-to-cart', SkioPlanPickerComponent);
